export default __webpack_public_path__ + "static/media/waterWithLemon.bbb7ecba.jpg";